import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class CancelAccountCountroller extends Controller {
  @service declare router: Router;
  @service declare store: Store;
  @service declare session: any;

  @tracked cancellingAccount = false;
  cancelReason?: string;

  @action
  templateWillDestroy() {
    this.cancellingAccount = false;
    this.cancelReason = undefined;
  }

  @action
  handleCancelReasonChanged(e: any) {
    this.cancelReason = e.target.value;
  }

  @action
  async cancelAccount() {
    if (this.cancellingAccount) {
      return;
    }
    let cancelAccount = this.store.createRecord('cancel-account');
    cancelAccount.cancelReason = this.cancelReason;
    await cancelAccount.save();
    await this.session.invalidate();
    this.router.transitionTo('account-cancelled');
  }
}
